import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';

const NotFound = () => {
    return (
        <div className="bg-light min-vh-100 d-flex flex-column justify-content-between">
            <Container className="text-center d-flex flex-column justify-content-center align-items-center flex-grow-1 py-5">
                <img
                    src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
                    alt="404"
                    style={{ maxWidth: '300px' }}
                    className="mb-4"
                />
                <h3 className="fw-bold mb-2">Something is wrong</h3>
                <p className="text-muted mb-4">
                    The page you are looking for was moved, removed, renamed<br />or might never existed!
                </p>
                <Button as={Link} to="/" variant="dark" className="rounded-circle px-3 py-2 fs-5">
                    ⬅
                </Button>
            </Container>

            <footer className="text-center text-muted py-3 border-top small">
                <span>Privacy Policy</span> | <span>Azz Enterprise</span>
            </footer>
        </div>
    );
};

export default NotFound;
